/* eslint-disable import-x/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default (keyword: string, ...args: any) => {
  const [suggestion] = args;
  const text: string = suggestion || chance.word();

  return {
    __typename: 'KeywordSuggestion',
    text,
    highlights: [
      {
        start:
          text.toLowerCase().indexOf(keyword.toLowerCase()) + keyword.length,
        end: text.length - 1,
      },
    ],
  };
};
